import React, {useState} from 'react';
import Box from '@mui/material/Box';
import TextFieldComp from '../../components/TextField/textFieldComp';
import ButtonComp from '../../components/Button/buttonComp';
import {useNavigate} from 'react-router-dom';
import Regex from '../../constants/regex';
import resetStyle from './resetOrSetPage.module.css';
import SuccessModal from '../../components/Modal/successModal';
import Strings from '../../constants/stringConstant';
import makeApiCall from '../../api/makeApiCall';
import {setPassword} from '../../api/request/registerApi/registerEmployee';
import {toast} from 'react-toastify';
import Path from '../../constants/path';
import TooltipComponent from '../../components/Tooltip/tooltip';
import {useDispatch, useSelector} from 'react-redux';
import {resetAllLocValues} from '../../state/slice/locationSlice';
import {useTranslation} from 'react-i18next';

function ResetOrSetPage() {
  const dispatch = useDispatch();
  const {locValue, userId} = useSelector(state => state.location);
  const [formData, setFormData] = useState({
    enterPassword: '',
    confirmPassword: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [userIdErrorHighlight, setUserIdErrorHighlight] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const {t: translator} = useTranslation();
  const handleChange = ({target: {name, value}}) => {
    setFormData(prev => ({
      ...prev,
      [name]: value.trim().replace(Regex.password_mismatch, ''),
    }));
    setFormErrors(prev => ({...prev, [name]: ''}));
    setUserIdErrorHighlight(false);
  };

  const handleBlur = ({target: {name, value}}) => {
    const errors = {};

    if (name === 'enterPassword') {
      if (!value || !Regex.password.test(value)) {
        errors.enterPassword = Strings.reset.enter_password;
      }
      if (formData.confirmPassword && value !== formData.confirmPassword) {
        errors.confirmPassword = Strings.reset.password_mismatch;
        setUserIdErrorHighlight(true);
      } else {
        errors.confirmPassword = '';
        setUserIdErrorHighlight(false);
      }
    }

    if (name === 'confirmPassword') {
      if (!value || !Regex.password.test(value)) {
        errors.confirmPassword = Strings.reset.enter_password;
      }
      if (formData.enterPassword && value !== formData.enterPassword) {
        errors.confirmPassword = Strings.reset.password_mismatch;
        setUserIdErrorHighlight(true);
      } else {
        errors.confirmPassword = '';
        setUserIdErrorHighlight(false);
      }
    }

    setFormErrors(prev => ({...prev, ...errors}));
  };

  const handleSubmit = async event => {
    event.preventDefault();

    const {enterPassword, confirmPassword} = formData;
    if (Object.keys(formErrors).every(key => !formErrors[key])) {
      try {
        const response = await makeApiCall(
          setPassword({
            userId: userId,
            password: enterPassword,
            reEnterPassword: confirmPassword,
            type: locValue,
          }),
        );

        if (response.data.status === Strings.success) {
          setOpenModal(true);
          setTimeout(() => {
            handleCloseModal();
          }, 2000);
        } else {
          if (response.data.status === Strings.error) {
            setFormErrors(prev => ({
              ...prev,
              confirmPassword: translator(
                'ErrorMessages.' + response.data.error.errorCode,
              ),
            }));
            setUserIdErrorHighlight(true);
          }
        }
      } catch (error) {
        toast.error(translator('ErrorMessages.' + 'SAMASTA001'), {
          position: 'top-right',
        });
        console.log('Login failed:', error);
      }
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    dispatch(resetAllLocValues());
    navigate(Path.login, {replace: true});
  };
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Box className={resetStyle.reset_set_container}>
      <Box className={resetStyle.reset_set_sub_container}>
        <Box className={`text-bold-22px ${resetStyle.reset_set_header}`}>
          {locValue === 'REGISTRATION'
            ? Strings.reset.set_password
            : Strings.reset.reset_password}
        </Box>
        <TooltipComponent
          anchorEl={anchorEl}
          handleClick={handleClick}
          handleClose={handleClose}
          id={id}
          open={open}
          content={Strings.tooltip}
        />
      </Box>
      <Box className={`text-medium-16px ${resetStyle.reset_set_subheader}`}>
        {Strings.reset.create_strong_password}
      </Box>
      <form onSubmit={handleSubmit} noValidate>
        <Box className={resetStyle.reset_set_password}>
          <TextFieldComp
            label={Strings.reset.password}
            name="enterPassword"
            value={formData.enterPassword}
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(formErrors.enterPassword) || userIdErrorHighlight}
            errorMessage={formErrors.enterPassword}
            minLength={8}
            maxLength={30}
            type="password"
          />
        </Box>
        <Box
          className={resetStyle.reset_set_password}
          sx={{paddingBottom: {xs: '14%', sm: '3%', md: '8%', lg: '7%'}}}>
          <TextFieldComp
            label={Strings.reset.confirm_password}
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(formErrors.confirmPassword)}
            errorMessage={formErrors.confirmPassword}
            minLength={8}
            maxLength={30}
            type="password"
          />
        </Box>
        <Box>
          <ButtonComp
            type="submit"
            onClick={handleSubmit}
            className="text-bold-16px"
            value={Strings.reset.continue}
            gradient="linear-gradient(168deg, #F37021 -13.5%, #FDBA12 119.9%)"
            height="48px"
            width="100%"
            padding="14px 24px"
            textcolor="#ffff"
            borderRadius="8px"
            marginTop={userIdErrorHighlight ? '10px' : '8px'}
            disabled={!formData.enterPassword || !formData.confirmPassword}
          />
        </Box>
      </form>
      <SuccessModal
        open={openModal}
        onClose={handleCloseModal}
        message={
          locValue === 'REGISTRATION'
            ? Strings.register.set_successfully
            : Strings.reset.reset_successfully
        }
        subMessage={
          locValue === 'REGISTRATION'
            ? Strings.register.password_set
            : Strings.reset.password_reset
        }
      />
    </Box>
  );
}

export default ResetOrSetPage;
